<template>
    <div class="columns is-mobile is-centered has-background-primary p-2">
        <h1 class="title is-4 has-text-white"><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; CONTATTO</h1>
    </div>

    <div class="box" @submit.prevent="" v-if="formAttivo">

        <div class="columns">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light"  @click="bAnnulla" :disabled="interfacciaBloccata || !elementoDaAggiornare">Annulla</button>
                    <button class="button is-primary" @click="bSalva" :disabled="interfacciaBloccata || !elementoDaAggiornare">Salva</button>
                </div>                
            </div>
        </div>

        <div class="columns">
        </div>

        <div class="columns">
            <div class="column is-2">
                <div class="field">
                    <label class="label">Titolo</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.titolo"  @change="elementoModifica(elementoSelezionato.titolo, 'titolo')">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label">Nome</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.nome"  @change="elementoModifica(elementoSelezionato.nome, 'nome')">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label">Cognome</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.cognome"  @change="elementoModifica(elementoSelezionato.cognome, 'cognome')">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label">Azienda</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.azienda"  @change="elementoModifica(elementoSelezionato.azienda, 'azienda')">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label">Telefono principale</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.telefono"  @change="elementoModifica(elementoSelezionato.telefono, 'telefono')">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label">Telefono</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.telefono2"  @change="elementoModifica(elementoSelezionato.telefono2, 'telefono2')">
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-4">
                <div class="field">
                    <label class="label">Mail principale</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.mail"  @change="elementoModifica(elementoSelezionato.mail, 'mail')">
                    </div>
                </div>
            </div>
            <div class="column is-4">
                <div class="field">
                    <label class="label">Mail</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.mail2" @change="elementoModifica(elementoSelezionato.mail2, 'mail2')">
                    </div>
                </div>
            </div>
            <div class="column is-4">
                <div class="field">
                    <label class="label">PEC</label>
                    <div class="control">
                        <input class="input" type="text" v-model="elementoSelezionato.pec" @change="elementoModifica(elementoSelezionato.pec, 'pec')">
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="label">Note</label>
                    <div class="control">
                        <textarea class="textarea" placeholder="Note"  rows="4" v-model="elementoSelezionato.note"  @change="elementoModifica(elementoSelezionato.note, 'note')"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns" v-if="credenzialiUtente.autorizzazione=='sviluppatore'">
            <div class="column is-11">
                <div class="field">
                    <label class="label">Note Marco</label>
                    <div class="control">
                        <textarea class="textarea is-danger" placeholder="Note"  rows="4" v-model="elementoSelezionato.noteMarco"  @change="elementoModifica(elementoSelezionato.noteMarco, 'noteMarco')"></textarea>
                    </div>
                </div>
            </div>
            <div class="column is-1" v-if="credenzialiUtente.autorizzazione=='sviluppatore'">
                <div class="field">
                    <label class="label">Rapporto</label>
                    <div class="checkbox">
                        <input type="checkbox"  v-model="elementoSelezionato.tu" @change="elementoModifica(elementoSelezionato.tu, 'tu')" />
                        Tu
                    </div>
                </div>
            </div>
        </div>

        <ElencoLeads
            :campoRicercaVisibile="false"
            :elencoTassativo="leggiInfoDBRaw(elementoSelezionato)?.leads || {}"
            @elementoSelezionato="gestisciSelezioneElemento"
            :titolo-visibile="true"
            v-if="props.idContatto != -1"
        />
        
        <ElencoLavori
            :campoRicercaVisibile="false"
            :elencoTassativo="leggiInfoDBRaw(elementoSelezionato)?.lavori || {}"
            @elementoSelezionato="gestisciSelezioneElemento"
            :titolo-visibile="true"
            v-if="props.idContatto != -1"
        />
        
    </div>

    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>

</template>

<script setup>
    import MessaggioModale from "./MessaggioModale.vue";
    import ElencoLeads from "./ElencoLeads.vue";
    import ElencoLavori from "./ElencoLavori.vue";
    import { defineProps, defineEmits, ref, watch, nextTick } from "vue";
    import { dbContatti, salvaContattoInFirestore, leggiInfoDBRaw, aggiungiInfoDB } from "./../code/gestioneDB";
    import { credenzialiUtente } from '../code/firebase';
    import { generaIdContatto, clonaOggetto } from "./../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idContatto: {
            type: Number,
            default: null
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso']);

    // VARIABILI DEL COMPONENTE
    const elementoSelezionato = ref({});
    const elementoDaAggiornare = ref(null);
    const messaggioModale = ref(null);
    const idElementoSelezionato = ref(props.idContatto || -1);
    const interfacciaBloccata = ref(false);
    const formAttivo = ref(true);

    // REATTIVITÀ
    watch(() => props.idContatto, (nuovoId) => {
        idElementoSelezionato.value = nuovoId || -1;
        setupForm();
    });

    // SETUP DEL COMPONENTE
    setupForm();

    // FUNZIONI DEL COMPONENTE
    function setupForm() {
        const id = idElementoSelezionato.value;

        const infoAttuali = leggiInfoDBRaw(elementoSelezionato.value) || {};
        
        // FIX: Evitiamo la trappola dell'oggetto vuoto salvando solo se ci sono realmente le chiavi
        let vecchiLeads = {};
        if (infoAttuali.leads && Object.keys(infoAttuali.leads).length > 0) {
            vecchiLeads = infoAttuali.leads;
        }

        let vecchiLavori = {};
        if (infoAttuali.lavori && Object.keys(infoAttuali.lavori).length > 0) {
            vecchiLavori = infoAttuali.lavori;
        }

        const scheletroBase = {
            titolo: null,
            nome: null,
            cognome: null,
            azienda: null,
            telefono: null,
            telefono2: null,
            mail: null,
            mail2: null,
            note: null,
            tu: false
        };

        elementoSelezionato.value = {};

        if ( id == -1 ) {
            elementoSelezionato.value = { ...scheletroBase };
            aggiungiInfoDB(elementoSelezionato.value, {
                id: -1,
                leads: {},
                lavori: {}
            });
        } else {
            const contattoOriginale = dbContatti.value[id];
            
            if (contattoOriginale) {
                elementoSelezionato.value = { ...scheletroBase, ...clonaOggetto(contattoOriginale) };
                
                const infoRaw = leggiInfoDBRaw(contattoOriginale) || { id: id };
                
                // FIX: Verifica se le proprietà non esistono o sono oggetti vuoti (es: {}) e reinietta la cache
                if (!infoRaw.leads || Object.keys(infoRaw.leads).length === 0) {
                    infoRaw.leads = vecchiLeads;
                }
                if (!infoRaw.lavori || Object.keys(infoRaw.lavori).length === 0) {
                    infoRaw.lavori = vecchiLavori;
                }
                
                aggiungiInfoDB(elementoSelezionato.value, infoRaw);
            } else {
                elementoSelezionato.value = { ...scheletroBase };
                aggiungiInfoDB(elementoSelezionato.value, { id: id, leads: vecchiLeads, lavori: vecchiLavori });
            }
        }
        elementoDaAggiornare.value = null;
    }

    function elementoModifica(valore, etichetta) {
        if (elementoDaAggiornare.value == null) {
            elementoDaAggiornare.value = {};
            emit('modificaElementoInCorso', true);
        }
        elementoDaAggiornare.value[etichetta] = valore;
        elementoSelezionato.value[etichetta] = valore; 
    }

    function bAnnulla() {
        if (elementoDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Cancella le modifiche', comando:'cancella'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        }
    }

    function bSalva() {
        if ( ( elementoSelezionato.value.telefono && String(elementoSelezionato.value.telefono).length > 3 && String(elementoSelezionato.value.telefono)[0] != '+')
            || ( elementoSelezionato.value.telefono2 && String(elementoSelezionato.value.telefono2).length > 3 && String(elementoSelezionato.value.telefono2)[0] != '+') ) {
                messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"I numeri di telefono devono iniziare con il prefisso internazionale +"
            };
        } else {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:{testo:'Salva', comando:'salva'},
                testoDanger:null,
                messaggio:"Vuoi salvare le modifiche al Contatto?"
            };
        }
    }

    // async function bComandoModale(comando) {
    //     switch (comando) {
    //         case 'annulla': {
    //             messaggioModale.value = null;
    //             break;
    //         }
    //         case 'cancella': {
    //             emit('modificaElementoInCorso', false);
    //             messaggioModale.value = null;
    //             setupForm();
    //             resetForm(); 
    //             break;
    //         }
    //         case 'salva': {
    //             if (idElementoSelezionato.value == -1) {
    //                 idElementoSelezionato.value = generaIdContatto();
    //             }
    //             aggiungiInfoDB(elementoDaAggiornare.value, {
    //                 id: idElementoSelezionato.value
    //             });
                
    //             if (elementoDaAggiornare.value.telefono) {
    //                 const strTel = String(elementoDaAggiornare.value.telefono);
    //                 const soloNumeri = strTel.replace(/\D/g, '');
    //                 if (soloNumeri.length > 0) {
    //                     elementoDaAggiornare.value.telefono = `+${soloNumeri}`;
    //                 } else {
    //                     elementoDaAggiornare.value.telefono = ""; 
    //                 }
    //             }
    //             if (elementoDaAggiornare.value.telefono2) {
    //                 const strTel2 = String(elementoDaAggiornare.value.telefono2);
    //                 const soloNumeri = strTel2.replace(/\D/g, '');
    //                 if (soloNumeri.length > 0) {
    //                     elementoDaAggiornare.value.telefono2 = `+${soloNumeri}`;
    //                 } else {
    //                     elementoDaAggiornare.value.telefono2 = ""; 
    //                 }
    //             }
                
    //             await salvaContattoInFirestore(elementoDaAggiornare.value);
    //             setupForm();
    //             messaggioModale.value = null;
    //             emit('modificaElementoInCorso', false);
    //             emit('elementoSelezionato', {
    //                 tipo: 'contatto',
    //                 idContatto: idElementoSelezionato.value
    //             });
    //             break;
    //         }
    //         case 'elimina': {
    //             break;
    //         }
    //     }
    // }

    async function bComandoModale(comando) {
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                setupForm();
                resetForm(); 
                break;
            }
            case 'salva': {
                if (idElementoSelezionato.value == -1) {
                    idElementoSelezionato.value = generaIdContatto();
                }
                
                // LMC FIX: Applichiamo i metadati DB all'oggetto COMPLETO, non al delta
                aggiungiInfoDB(elementoSelezionato.value, {
                    id: idElementoSelezionato.value
                });
                
                // LMC FIX: Formattiamo i numeri di telefono sull'oggetto COMPLETO
                if (elementoSelezionato.value.telefono) {
                    const strTel = String(elementoSelezionato.value.telefono);
                    const soloNumeri = strTel.replace(/\D/g, '');
                    if (soloNumeri.length > 0) {
                        elementoSelezionato.value.telefono = `+${soloNumeri}`;
                    } else {
                        elementoSelezionato.value.telefono = ""; 
                    }
                }
                if (elementoSelezionato.value.telefono2) {
                    const strTel2 = String(elementoSelezionato.value.telefono2);
                    const soloNumeri = strTel2.replace(/\D/g, '');
                    if (soloNumeri.length > 0) {
                        elementoSelezionato.value.telefono2 = `+${soloNumeri}`;
                    } else {
                        elementoSelezionato.value.telefono2 = ""; 
                    }
                }
                
                // LMC FIX: Inviamo a Firebase l'intero oggetto per evitare la race condition visiva su mobile
                await salvaContattoInFirestore(elementoSelezionato.value);
                
                setupForm();
                messaggioModale.value = null;
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'contatto',
                    idContatto: idElementoSelezionato.value
                });
                break;
            }
            case 'elimina': {
                break;
            }
        }
    }

    function gestisciSelezioneElemento(elSelezionato) {
        emit('elementoSelezionato', elSelezionato);
    }

    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }

</script>